module.exports = __webpack_public_path__ + "img/plat_4964.5f0c3b73.jpg";